import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getVoting } from '../../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions, setSurveyNoTextError, setSurveyUserSelection, setSurveySubmissionError, setSurveySubmissionSuccess } from '../../redux/data/dataSlice';
import { useEffect, useState } from "react";
import config from "../../config/memberhubContents.json";
import ArrowLeft from "../../assets/images/arrow-left.svg";
import ArrowRight from "../../assets/images/arrow-right.svg";

function SurveyFooter(props) {
    const dispatch = useDispatch();
    const surveyCompleted = useSelector(state => state.data.surveySubmissionSuccess);
    const questions = props && props.questions;
    const currentQuestionIndex = props && props.current;
    const skipEnabled = questions && questions[currentQuestionIndex] && questions[currentQuestionIndex].required === false;
    const back = props && props.back;
    const disabled = props && props.disabled;
    const next = props && props.next;
    const skip = props && props.skip;
    const submit = props && props.submit;
    const surveyTaken = props && props.surveyTaken;
    const first = currentQuestionIndex === 0;
    const last = currentQuestionIndex === questions.length - 1;
    const singleQuestion = questions.length === 1;
    const reviewing = currentQuestionIndex === questions.length;
    const surveyMinProgressBarPct = 0.05;
    const surveyMaxProgressBarPct = 0.9;
    const surveyReviewingProgressBarPct = 0.95;
    const surveyCompletedProgressBarPct = 1;
    const [currentPct, setCurrentPct] = useState(0);

    useEffect(() => {
        let pct = (() => {
            if (surveyCompleted || surveyTaken) return surveyCompletedProgressBarPct;
            if (reviewing) return surveyReviewingProgressBarPct;
            if (last) return surveyMaxProgressBarPct;
            if (first) return surveyMinProgressBarPct;

            if (props.current !== undefined && props.questions && props.questions.length > 0) {
                return ((props.current + 1) / props.questions.length);
            }

            return 0;
        })();

        setCurrentPct(pct * 100);
    }, [props, surveyCompleted, surveyTaken, first, last, reviewing]);

    return (
        <div className="modal-footer quiz-footer">
            {questions.length !== 1 &&
                <div className="modal-progress-bar">
                    <div className="progress-bar-text">{surveyCompleted || surveyTaken ? 'Complete' : reviewing ? 'Review' :
                        `${currentQuestionIndex + 1} of ${questions.length}`}</div>
                    <div className="progress-bar-container">
                        <div className="progress-bar-inner" style={{ width: `${currentPct}%` }}></div>
                    </div>
                </div>
            }
            <div className="modal-cta-group">
                { /* Completed */
                    (surveyCompleted || surveyTaken) &&
                    <Link
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getVoting());
                            dispatch(setPhoneNumber(""));
                            dispatch(setTermsAndConditions(false));
                            dispatch(setSurveyUserSelection([]));
                            dispatch(setSurveySubmissionSuccess(false));
                            dispatch(setSurveySubmissionError(null));
                            dispatch(setSurveyNoTextError(false));
                        }}
                        className="modal-button-cta"
                        to={{ pathname: "/voting", search: window.location.search }}
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="voting"
                        data-type="dismiss">
                        {config.returnToBenefits}
                    </Link>
                }
                { /* Review */
                    !surveyCompleted && !surveyTaken && reviewing &&
                    <>
                        <div
                            onClick={() => back()}
                            className="modal-button-cta"
                            data-track="click"
                            data-type="cta">
                            <img src={ArrowLeft} alt="Back" className="modal-icon" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                            {config.back}
                        </div>
                        <div
                            onClick={submit}
                            className="modal-button-cta"
                            data-track="click"
                            data-id="nba:membership-hub:outbound:cta"
                            data-type="cta">
                            {config.submit}
                            <img src={ArrowRight} alt="Submit" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                        </div>
                    </>
                }
                { /* Single Question */
                    !surveyCompleted && !surveyTaken && singleQuestion &&
                    <div
                        onClick={submit}
                        className={`modal-button-cta ${disabled ? 'disabled' : ''}`}
                        data-track="click"
                        data-id="nba:membership-hub:outbound:cta"
                        data-type="cta">
                        {config.submit}
                        <img src={ArrowRight} alt="Submit" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                    </div>
                }
                { /* First Question in Multiple Question Quiz */
                    !surveyCompleted && !surveyTaken && !singleQuestion && first &&
                    <div
                        onClick={() => next()}
                        className={`modal-button-cta ${disabled ? 'disabled' : ''}`}
                        data-track="click"
                        data-type="cta">
                        {config.next}
                        <img src={ArrowRight} alt="Next" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                    </div>
                }
                { /* Intermediate Question in Muliple Question Quiz */
                    !surveyCompleted && !surveyTaken && !singleQuestion && !first && !reviewing &&
                    <>
                        <div
                            onClick={() => back()}
                            className="modal-button-cta"
                            data-track="click"
                            data-type="cta">
                            <img src={ArrowLeft} alt="Back" className="modal-icon" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                            {config.back}
                        </div>
                        <div
                            onClick={() => next()}
                            className={`modal-button-cta ${disabled ? 'disabled' : ''}`}
                            data-track="click"
                            data-type="cta">
                            {config.next}
                            <img src={ArrowRight} alt="Next" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                        </div>
                    </>
                }
            </div>
            {skipEnabled && <div className="modal-cta-skip" onClick={() => skip()}>Skip</div>}
        </div>
    );
}

export default SurveyFooter;